import React from 'react'

const Events: React.FC<DefaultPropsIcon> = (props) => {
  const { size = 24, onClick, className, color = '#818C99' } = props
  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          id="↳ Icon Color"
          fill={color}
          fillRule="nonzero"
          d="m4 13.828 5.818 5.818a4.5 4.5 0 0 0 6.364 0l3.503-3.503a3 3 0 0 1-.806 2.778l-2.344 2.344a5 5 0 0 1-7.07 0l-4.293-4.293A4 4 0 0 1 4 14.143zm14.879.293-4.111 4.111a2.5 2.5 0 0 1-3.536 0l-6.06-6.06A4 4 0 0 1 4 9.343V5.5A2.5 2.5 0 0 1 6.5 3h3.843a4 4 0 0 1 2.829 1.172l5.707 5.707a3 3 0 0 1 0 4.242M9 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
        ></path>
      </svg>
    </span>
  )
}

export default Events
